import { useWindowSize as useWindowsSizeReactUse } from 'react-use';

import { breakpoints } from 'src/constants/breakpoints';

// This hook is used to get the current window size and return a boolean for each breakpoint.
// It looks like hook `useBreakpoints` but is slightly different because it has different breakpoints.
export const useWindowSize = () => {
    const { width } = useWindowsSizeReactUse();
    return {
        isMobile: width < breakpoints.tabletPortrait,
        isTabletPortrait: width < breakpoints.tabletLandscape && width >= breakpoints.tabletPortrait,
        isTabletLandscape: width < breakpoints.desktopSmall && width >= breakpoints.tabletLandscape,
        isDesktopSmall: width < breakpoints.desktopLarge && width >= breakpoints.desktopSmall,
        isDesktopLarge: width >= breakpoints.desktopLarge,
    };
};
